import { Button, List, ListItem } from "@material-ui/core";
import React, { memo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PuiTypography from "../../../components/elements/PuiTypography";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { useInitNumber } from "../../../components/function/useInitNumber";
import { useInitText } from "../../../components/function/useInitText";
import { AppState } from "../../../root/RootReducer";
import { TimelineInfo } from "../../models/Timeline";
import RenameObjectModal from "../../../common/components/modal/RenameObjectModal";
import styles from "./TimelineTopList.module.css";
import { MoreVert } from "@material-ui/icons";
import { t } from "i18next";

interface TimelineTopListProps {
    timelineList: TimelineInfo[];
    displayTimeline: number;
    handleClickVideo: (videoFileUrl: React.SetStateAction<string>) => void;
    handleExportMessage: (id: number) => void;
    OpenUploadTimelineModal: (timeline: TimelineInfo) => void;
    handleUploadingMessage: (id: number) => void;
    handleCompleted: (timeline: TimelineInfo) => void;
    handleErrorMessage: (timeline: TimelineInfo) => void;
    handleDeleteTimeline: (id: number) => void;
    isExistList: boolean;
    timelineInfoList: TimelineInfo[];
}

function TimelineTopList({
    timelineList,
    displayTimeline,
    handleClickVideo,
    handleExportMessage,
    OpenUploadTimelineModal,
    handleUploadingMessage,
    handleCompleted,
    handleErrorMessage,
    handleDeleteTimeline,
    isExistList,
    timelineInfoList,
}: TimelineTopListProps) {
    // storeから値取得
    const { isSuccessGetTimelines } = useSelector((state: AppState) => ({
        isSuccessGetTimelines: state.timeline.isSuccessGetTimelines,
    }));

    const history = useHistory();

    // index
    const [openUploadMessageIndex, setOpenUploadMessageIndex] = useState<number>(-1);
    const [openErrorMessageIndex, setOpenErrorMessageIndex] = useState<number>(-1);
    const [openUploadcancelMessageIndex, setOpenUploadcancelMessageIndex] = useState<number>(-1);
    const [openExportcancelMessageIndex, setOpenExportCancelMessageIndex] = useState<number>(-1);
    const [openEditingMessageIndex, setOpenEditingMessageIndex] = useState<number>(-1);
    const [openCreateCancelingMessageIndex, setOpenCreateCancelingMessageIndex] =
        useState<number>(-1);
    const [openCompletedMessageIndex, setOpenCompletedMessageIndex] = useState<number>(-1);

    // テンプレート名変更処理
    const [editTemplateId, setEditTemplateId] = useInitNumber();
    const [editTemplateName, setEditTemplateName] = useInitText();

    // フォルダ名編集ポップアップ表示フラグ
    const [isOpenRenameTimelineModal, setOpenRenameTimelineModal] = useInitFlag();

    // 名前変更ボタンを押下の場合、
    const handleRenameTimeline = (id: number, name: string) => {
        setEditTemplateId(id);
        setEditTemplateName(name);
        setOpenRenameTimelineModal(true);
    };

    const [directoryIndex, setDerectoryIndex] = useState<number>(-1);

    const ChangeDirectoryIndex = (index: number) => {
        setDerectoryIndex(index);
    };

    const deleteTimeline = (timelineId: number) => {
        setDerectoryIndex(-1);
        handleDeleteTimeline(timelineId);
    };

    const renameTimeline = (id: number, name: string) => {
        setDerectoryIndex(-1);
        handleRenameTimeline(id, name);
    };

    return (
        <List className={styles.timelineArea}>
            {timelineList &&
                timelineList.length > 0 &&
                timelineList.slice(displayTimeline, displayTimeline + 10).map((timeline, index) => (
                    <ListItem key={index} className={styles.columnBody}>
                        <div className={styles.columnLeft}>
                            <div className={styles.title}>
                                <div
                                    onClick={() => {
                                        timeline.status !== "CREATING" &&
                                            history.push("./editTimeline/" + timeline.id);
                                    }}
                                    style={{
                                        cursor: timeline.status !== "CREATING" ? "pointer" : "auto",
                                        maxWidth:
                                            timeline.status === "CREATED" ||
                                            timeline.status === "UPLOAD_CANCELING" ||
                                            timeline.status === "COMPLETED"
                                                ? "calc(100% - 39px)"
                                                : "",
                                    }}
                                >
                                    <PuiTypography>{timeline.name}</PuiTypography>
                                </div>
                                {/* 書き出し済みの場合previewアイコン表示 */}
                                {(timeline.status === "CREATED" ||
                                    timeline.status === "UPLOAD_CANCELING" ||
                                    timeline.status === "COMPLETED") && (
                                    <div
                                        onClick={() =>
                                            handleClickVideo(
                                                process.env.REACT_APP_API_ENDPOINT +
                                                    "/api/timeline/" +
                                                    timeline.id
                                            )
                                        }
                                        className={styles.playIcon}
                                    ></div>
                                )}
                            </div>
                            <div className={styles.date}>
                                <PuiTypography>{timeline.updated}</PuiTypography>
                            </div>

                            {/* statusが編集中の場合 */}
                            {(timeline.status === "IS_EDITING" ||
                                timeline.status === "UNEDITED") && (
                                <>
                                    <div
                                        className={styles.message}
                                        onMouseEnter={() => setOpenEditingMessageIndex(index)}
                                        onMouseLeave={() => setOpenEditingMessageIndex(-1)}
                                    >
                                        <PuiTypography>{t("編集中")}</PuiTypography>
                                    </div>
                                    {openEditingMessageIndex === index && (
                                        <div
                                            className={styles.hoverStatusButton}
                                            style={{ right: "36px" }}
                                        >
                                            <PuiTypography color="white">
                                                {t("編集中のプロジェクトです")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusが書き出し中の場合 */}
                            {timeline.status === "CREATING" && (
                                <>
                                    <div
                                        className={styles.message}
                                        onClick={() => {
                                            handleExportMessage(timeline.id);
                                        }}
                                        onMouseEnter={() => setOpenExportCancelMessageIndex(index)}
                                        onMouseLeave={() => setOpenExportCancelMessageIndex(-1)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <PuiTypography>{t("書き出し中")}</PuiTypography>
                                    </div>
                                    {openExportcancelMessageIndex === index && (
                                        <div className={styles.hoverStatusButton}>
                                            <PuiTypography color="white">
                                                {t("書き出しのキャンセルが出来ます")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusが書き出しキャンセル中の場合 */}
                            {timeline.status === "CREATE_CANCELING" && (
                                <>
                                    <div
                                        className={styles.message}
                                        onMouseEnter={() =>
                                            setOpenCreateCancelingMessageIndex(index)
                                        }
                                        onMouseLeave={() => setOpenCreateCancelingMessageIndex(-1)}
                                        style={{ textAlign: "center" }}
                                    >
                                        <PuiTypography>
                                            {t("書き出し")}
                                            <br />
                                            {t("キャンセル中")}
                                        </PuiTypography>
                                    </div>
                                    {openCreateCancelingMessageIndex === index && (
                                        <div
                                            className={styles.hoverStatusButton}
                                            style={{ right: "-26px" }}
                                        >
                                            <PuiTypography color="white">
                                                {t("書き出しキャンセル中のプロジェクトです")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusが書き出し済みかアップロードキャンセルした場合 */}
                            {(timeline.status === "CREATED" ||
                                timeline.status === "UPLOAD_CANCELING") && (
                                <>
                                    <div
                                        className={styles.uploadButton}
                                        onMouseEnter={() => setOpenUploadMessageIndex(index)}
                                        onMouseLeave={() => setOpenUploadMessageIndex(-1)}
                                    >
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            type="submit"
                                            onClick={() => {
                                                OpenUploadTimelineModal(timeline);
                                            }}
                                        >
                                            {t("アップロード")}
                                        </Button>
                                    </div>
                                    {openUploadMessageIndex === index && (
                                        <div className={styles.hoverStatusButton}>
                                            <PuiTypography color="white">
                                                {t("cineonhubにアップロードできます")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusがアップロード中の場合 */}
                            {timeline.status === "UPLOADING" && (
                                <>
                                    <div
                                        className={styles.message}
                                        onClick={() => handleUploadingMessage(timeline.id)}
                                        onMouseEnter={() => setOpenUploadcancelMessageIndex(index)}
                                        onMouseLeave={() => setOpenUploadcancelMessageIndex(-1)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <PuiTypography>{t("アップロード中")}</PuiTypography>
                                    </div>
                                    {openUploadcancelMessageIndex === index && (
                                        <div
                                            className={styles.hoverStatusButton}
                                            style={{ right: "-5px" }}
                                        >
                                            <PuiTypography color="white">
                                                {t("アップロードのキャンセルが出来ます")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusが完了の場合 */}
                            {timeline.status === "COMPLETED" && (
                                <>
                                    <div
                                        className={styles.message}
                                        onMouseEnter={() => setOpenCompletedMessageIndex(index)}
                                        onMouseLeave={() => setOpenCompletedMessageIndex(-1)}
                                        onClick={() => handleCompleted(timeline)}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        <PuiTypography>{t("完了")}</PuiTypography>
                                    </div>
                                    {openCompletedMessageIndex === index && (
                                        <div
                                            className={styles.hoverStatusButton}
                                            style={{ right: "36px" }}
                                        >
                                            <PuiTypography color="white">
                                                {t("再アップロードが出来ます")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                            {/* statusがエラーの場合 */}
                            {timeline.status === "ERROR" && (
                                <>
                                    <div
                                        className={styles.error}
                                        onMouseEnter={() => setOpenErrorMessageIndex(index)}
                                        onMouseLeave={() => setOpenErrorMessageIndex(-1)}
                                        onClick={() => {
                                            handleErrorMessage(timeline);
                                        }}
                                    >
                                        <PuiTypography>{t("エラー")}</PuiTypography>
                                    </div>
                                    {openErrorMessageIndex === index && (
                                        <div
                                            className={styles.hoverStatusButton}
                                            style={{ right: "56px" }}
                                        >
                                            <PuiTypography color="white">
                                                {t("エラーが発生しました")}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                        <div onClick={() => ChangeDirectoryIndex(index)} className={styles.icon}>
                            <MoreVert />
                        </div>
                        {index === directoryIndex && (
                            <>
                                <div className={styles.menuItem}>
                                    <div onClick={() => renameTimeline(timeline.id, timeline.name)}>
                                        <PuiTypography>{t("名前を変更")}</PuiTypography>
                                    </div>
                                    <div onClick={() => deleteTimeline(timeline.id)}>
                                        <PuiTypography> {t("削除")}</PuiTypography>
                                    </div>
                                </div>
                                <div
                                    className={styles.bg}
                                    onClick={() => ChangeDirectoryIndex(-1)}
                                />
                            </>
                        )}
                    </ListItem>
                ))}
            {timelineList && timelineList.length === 0 && isExistList && (
                <div className={styles.noProject}>
                    <PuiTypography>{t("プロジェクトが見つかりませんでした。")}</PuiTypography>
                </div>
            )}
            {isSuccessGetTimelines && timelineInfoList && timelineInfoList.length === 0 && (
                <div className={styles.noProject}>
                    <PuiTypography>{t("プロジェクトが登録されていません。")}</PuiTypography>
                </div>
            )}
            {/* テンプレート名変更モーダルを呼び出す */}
            <RenameObjectModal
                isOpenModal={isOpenRenameTimelineModal}
                setOpenModal={setOpenRenameTimelineModal}
                id={editTemplateId}
                editName={editTemplateName}
                setEditName={setEditTemplateName}
                type={t("プロジェクト")}
            />
        </List>
    );
}
export default memo(TimelineTopList);
